import LoadingPopUp from './LoadingPopUp';
export default LoadingPopUp;
